import { ActionColumnDowload } from 'src/pages/Sessions/utils/ColumnFormatters/ActionColumnDowload';

export const columns = (onDownload) => [
	{
		dataField: 'nombre',
		text: 'Archivo',
		style: { maxWidth: '250px' },
		headerAlign: 'left',
	},
	{
		dataField: 'nombreUsuario',
		text: 'Usuario',
		headerAlign: 'left',
	},
	{
		dataField: 'fecha',
		text: 'Fecha',
		headerAlign: 'left',
	},
	{
		dataField: 'hora',
		text: 'Hora',
		headerAlign: 'left',
	},
	{
		dataField: 'ruta',
		text: 'Descargar Archivo',
		classes: 'text-center',
		formatter: ActionColumnDowload,
		formatExtraData: {
			onDownload,
		},
	},
];
